module.exports = __webpack_public_path__ + "static/media/bookmarkRemove.b5d6247c.svg";